export const withTranslatedTasticData = (WrappedComponent) => {
  return WrappedComponent;
};

export default withTranslatedTasticData;
